<input  class="form-control" 
        type="number" 
        required 
        [formControl]="quantity" 
        [ngStyle]="{'text-align':'right'}"
        (blur)="onBlur()" >
<small *ngIf="quantity.invalid 
&& (quantity.dirty || quantity.touched)" class="text-danger">
    Should be Numeric
</small>